import React from "react";

import PropTypes from "prop-types";
import Feature from "byzantine/src/Feature";
import SecurityAlerts from "./alerts/SecurityAlerts";
import TransactionAndBalanceAlerts from "./alerts/TransactionAndBalanceAlerts";
import MultiFactorAuthentication from "./mfa/MultiFactorAuthentication";
import DualApprovalOptInContainer from "../../DualApproval/DualApprovalOptInReact";
import ThirdPartyDataAccess from "./third_party_data/ThirdPartyDataAccess";
import { useInstitutionSettings } from "../../contexts/InstitutionSettingsContext";
import styles from "./SecuritySettingsContainer.module.scss";

const SecuritySettingsContainer = ({ accounts, devices, features }) => {
  // MultiFactorAuthentication is positioned at the top because we want to make it as easy as possible
  // for users to find where to add MFA devices
  const parsedDevices = JSON.parse(devices);
  const { fdx_api_enabled: fdxApiEnabled } = useInstitutionSettings();

  return (
    <div className={styles.container}>
      <Feature features={features} flag="enhanced_alerts">
        <div className={styles.column}>
          <MultiFactorAuthentication initialDevices={parsedDevices} />
          <DualApprovalOptInContainer />
          {fdxApiEnabled && (
            <Feature features={features} flag="data_access_management">
              <ThirdPartyDataAccess />
            </Feature>
          )}
        </div>
      </Feature>
      <Feature features={features} not="enhanced_alerts">
        <div className={styles.column}>
          <Feature features={features} flag="alerts">
            <TransactionAndBalanceAlerts accounts={accounts} />
          </Feature>
          <SecurityAlerts />
        </div>
        <div className={styles.column}>
          <MultiFactorAuthentication initialDevices={parsedDevices} />
          <DualApprovalOptInContainer />
          {fdxApiEnabled && (
            <Feature features={features} flag="data_access_management">
              <ThirdPartyDataAccess />
            </Feature>
          )}
        </div>
      </Feature>
    </div>
  );
};
SecuritySettingsContainer.propTypes = {
  accounts: PropTypes.array,
  devices: PropTypes.string,
  features: PropTypes.object,
};

export default SecuritySettingsContainer;
